<template>
  <b-card
      title="مدیریت سوالات متداول"
  >
    <b-row>
      <b-col
          class="table-size"
      >

        <b-tree-view v-if="items" :nodesDraggable="true" @nodeSelect="select" :renameNodeOnDblClick="false" :contextMenu="true" :contextMenuItems="contextMenuItems" @contextMenuItemSelect="menuItemSelected" :data="items"></b-tree-view>

        <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            class="mb-1 mr-1"
            variant="warning"
            @click="isShow = true"
        >فیلتر
        </b-button>

        <b-modal
            v-model="isShow"
            v-if="isShow"
            ok-title="ذخیره"
            cancel-title="انصراف"
            cancel-variant="outline-secondary"
            centered
            title="افزودن"
            :no-close-on-backdrop="true"
            size="sm"
            @ok="save"
        >

          <b-col md="12">
            <b-form-group
                label="عنوان"
                label-for="Title"
            >
              <b-form-input
                  v-model="row.Title"
                  autocomplete="off"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
                label="MenuId"
                label-for="MenuId"
            >
              <b-form-input
                  v-model="row.MenuId"
                  autocomplete="off"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
                label="Id"
                label-for="Id"
            >
              <b-form-input
                  v-model="row.Id"
                  autocomplete="off"
              />
            </b-form-group>
          </b-col>

        </b-modal>

      </b-col>

    </b-row>
  </b-card>
</template>

<script>

import ZFaqCategory from '@/tools/faqcategory.vue'
import { bTreeView } from 'bootstrap-vue-treeview'

export default {
  name: 'Faq',
  components: {
    ZFaqCategory,
    bTreeView,
  },
  data() {
    return {
      treeData: [ ],
      totalRows: 1000 * 1000,
      loading: false,
      isShow: false,
      filterOptions: {
        Title: null,
        Page: 1,
        FaqCategoryId: null,
        SortBy: 'Id',
        IsDesc: true,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },

        {
          key: 'Title',
          label: 'عنوان',
          sortable: true,
        },
        {
          key: 'FaqCategory',
          label: 'دسته بندی',
        },
        {
          key: 'Like',
          label: 'لایک',
          sortable: true,
        },
        {
          key: 'Dislike',
          label: 'دیسلایک',
          sortable: true,
        },
        {
          key: 'Sort',
          label: 'ترتیب',
          sortable: true,
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      row: {},
      contextMenuItems: [{code: 'DELETE_NODE', label: 'Delete node'}, {
        code: 'ADD_CHILD_NODE',
        label: 'Add child'
      }, {code: 'RENAME_NODE', label: 'Rename'}]
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        if (this.filterOptions.SortBy === 'Sort') {
          this.filterOptions.SortBy = 'Priority'
        }
        this.filterOptions.IsDesc = e.sortDesc
        this.update(1)
      }
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', {key: this.$options.name, value: this.filterOptions})

      this.$http.post(
          this.$api.menu.getall, this.filterOptions,
      )
          .then(res => {

            this.items = []

            res.data.filter(x=>x.MenuId == null).forEach(item=>{

              var firstLevel = { 'id':item.Id, 'name': item.Title, 'children':[]}

              this.getChildren(firstLevel, res.data)

              this.items.push(firstLevel)


              })
          })
          .finally(() => {
            this.loading = false
          })
    },
    select(row, isSelected) {
      if (isSelected) {
        this.row.Title = row.data.name
        this.row.Id = row.data.id

        this.isShow = true
      }
    },
    remove(id) {
      this.removeRow(this.$api.faq.remove, 'Id', id)
    },
    save(){
      let url = this.$api.menu.add

      if (this.row.Id){
        url= this.$api.menu.update
      }



      this.$http.post(url, this.row).then(() => {
        this.update()
      })


    },

    menuItemSelected(item, node) {
      console.log(item)
      if (item.code === 'ADD_CHILD_NODE') {
        node.appendChild({
          id: 100,
          name: 'My new node'
        })
      }
    },

    getChildren(record, data){

      data.filter(x=>x.MenuId == record.id).forEach(item=>{

        var a = { 'id':item.Id, 'name': item.Title, 'children':[]}

        if (data.filter(x=>x.MenuId == item.Id).length){
          this.getChildren(a, data)
        }

        record.children.push(a)
      })

    }
  },
}
</script>
